import FundebIndex from "@/Pages/Fundeb/index.vue";
import FundebConfiguracoes from "@/Pages/Fundeb/Configuracoes.vue";
import semPermissaoFundeb from "@/router/guards/semPermissaoFundeb";

export default [
  {
    path: "/fundeb/calculadora",
    name: "fundeb.calculadora",
    component: FundebIndex,
    beforeEnter: async (to, from, next) => {
      await semPermissaoFundeb(to, from, next);
      return next();
    },
  },
  {
    path: "/fundeb/configuracoes",
    name: "fundeb.configuracoes",
    component: FundebConfiguracoes,
    beforeEnter: async (to, from, next) => {
      await semPermissaoFundeb(to, from, next);
      return next();
    },
  },
];
